import { useState, useEffect } from "react";

/**
 * @module useOnline
 * @description
 * Hook to track whether the user is online or offline.
 * 
 * @returns {boolean} `true` if the user is online, `false` otherwise.
 */
const useOnline = () => {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    /**
     * Handler for the "online" event, which is emitted when the
     * user comes back online.
     *
     * Sets the `isOnline` state to `true`.
     */
    const handleOnline = () => {
      setIsOnline(true);
    };
    /**
     * Handler for the "offline" event, which is emitted when the
     * user goes offline.
     *
     * Sets the `isOnline` state to `false`.
     */
    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline;
};

export default useOnline;